import { Grid,GridProps } from "@mui/material";

export type GridContainerProps = GridProps

const GridContainer = ({ children, ...props}: GridContainerProps) => {
  return <Grid {...{
    spacing: '24px',
      ...props,
    container: true,
  }}>{ children }</Grid>
}

export default GridContainer